import ElTableEdit from './el-table-edit.vue'
import ElTableEditCell from './el-table-edit-cell.vue'

ElTableEdit.install = function (Vue) {
    Vue.component(ElTableEdit.name, ElTableEdit)
    Vue.component(ElTableEditCell.name, ElTableEditCell)
}

export default ElTableEdit
